var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("PHP Sending email example code")]),_c('PhpGist')],1)}
var staticRenderFns = []

export { render, staticRenderFns }